module.exports = __webpack_public_path__ + "static/media/login_background.9e71d176.jpg";